import { RouteObject } from "react-router-dom";
import { PolicyPageRoutesConfig } from "./config";
import PolicyPage from "../routes/PolicyPage";

export const PolicyPageRoutes: RouteObject = {
  path: `${PolicyPageRoutesConfig.policyHome}:policyType`,
  element: <PolicyPage />,
};
